const COMMON_COLUMNS = [
  {
    key: "influence",
    dataIndex: "influence",
    title: "Influence",
    width: 135,
  },
  {
    key: "strength",
    dataIndex: "strength",
    title: "Strength",
    width: 135,
  },
];

const getNormalColumns = () => [
  {
    key: "value",
    dataIndex: "value",
    title: "Value",
  },
  ...COMMON_COLUMNS,
];

const getBinaryMergeColumns = (node, graphMap) => {
  const leftNode = graphMap[node.left];
  const rightNode = graphMap[node.right];

  if (
    !leftNode ||
    !rightNode ||
    leftNode?.node_type["@type"] === "binary_merge" ||
    rightNode?.node_type["@type"] === "binary_merge"
  ) {
    return getNormalColumns();
  }

  const leftLabel = leftNode.node_type?.column_name ?? leftNode.id?.slice(1);
  const rightLabel = rightNode.node_type?.column_name ?? rightNode.id?.slice(1);

  return [
    {
      title: "Value",
      children: [
        { key: leftNode?.id, dataIndex: leftLabel, title: leftLabel },
        { key: rightNode?.id, dataIndex: rightLabel, title: rightLabel },
      ],
    },
    ...COMMON_COLUMNS,
  ];
};

const getColumns = (node, graphMap) => {
  switch (node?.["@type"]) {
    case "binary_merge":
      return getBinaryMergeColumns(node, graphMap);
    default:
      return getNormalColumns();
  }
};

export { getColumns };
